import { memo, useContext } from "react";
import { GlobalProvider } from "../Context/GlobalState";
//import { Link } from "react-router-dom";
import { GlobalContext } from "../Context/GlobalState";

function Footer() {
  const { isLogin } = useContext(GlobalContext);
  const dt = new Date();
  return isLogin ? (
    <GlobalProvider>
      <div className="container">
        <footer className="py-3 my-4">
          {/* <ul className="nav justify-content-center border-bottom pb-3 mb-3">
            <li className="nav-item">
              <Link to={isLogin ? "/home" : "/"}>
                <p className="nav-link px-2 text-body-secondary">Anasayfa</p>
              </Link>
            </li>
            <li className="nav-item">
              <a href="/" className="nav-link px-2 text-body-secondary">
                Raporlar
              </a>
            </li>
            <li className="nav-item">
              <a href="/" className="nav-link px-2 text-body-secondary">
                Bağış Yap
              </a>
            </li>
            <li className="nav-item">
              <a href="/" className="nav-link px-2 text-body-secondary">
                S.S.S
              </a>
            </li>
            <li className="nav-item">
              <a href="/" className="nav-link px-2 text-body-secondary">
                Hakkımızda
              </a>
            </li>
          </ul> */}
          <p className="text-center text-body-secondary">
            © {dt.getFullYear()}{" "}
            <a href="mailto:info@ziraatbilirkisileri.com">
              info@ziraatbilirkisileri.com
            </a>
          </p>
        </footer>
      </div>
    </GlobalProvider>
  ) : (
    ""
  );
}

export default memo(Footer);
